'use client'

import React from 'react'
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import cad from '../assets/icons8-3d-printer-64.png';
import web from '../assets/icons8-internet-64.png';
import systemAdmin from '../assets/icons8-server-64.png';
import network from '../assets/icons8-networking-manager-64.png';
import cloudBackup from '../assets/icons8-cloud-storage-64.png';
import cloud from '../assets/icons8-cloud-64.png';

const perks = [
  {
    name: 'System Administration',
    imageSrc: systemAdmin,
    description:
      'Over two decades of hands-on experience deploying and maintaining Windows, macOS, and Linux environments... Expert in crafting advanced automation scripts with Python and Bash to streamline day-to-day operations.',
  },
  {
    name: 'Network Infrastructure & Security',
    imageSrc: network,
    description:
      'Expert in LAN, VLAN, QoS, firewall management, VPN, and routers/switches... Dedicated to configuring robust firewalls and security protocols to protect mission-critical data.',
  },
  {
    name: 'Cloud & Virtualization',
    imageSrc: cloud,
    description:
      'Experience with VMware, Hyper-V, Microsoft Azure, Google Cloud, Intune, Office 365... Proficient in designing scalable cloud architectures that optimize resource usage and reduce costs.',
  },
  {
    name: 'Web Development & Automation',
    imageSrc: web,
    description:
      'Specialized in the LAMP stack, MERN stack, AngularJS, Python, and automation scripting... Successfully built custom ERP solutions that boost productivity and streamline organizational workflows.',
  },
  {
    name: 'Data Backup & Recovery',
    imageSrc: cloudBackup,
    description:
      'Plan and maintain on-premises and cloud backup strategies, with attention to retention, recovery procedures and restore testing. Recovery requirements should be reviewed as systems and business needs change.',
  },
  {
    name: 'CAD Design & Support',
    imageSrc: cad,
    description:
      'Skilled in creating and modifying system designs with AutoCAD... Adept at collaborating with project managers and engineers to deliver precise, compliant drawings for large-scale builds.',
  },
]





const Expertise = () => {
  return (
    <section className="home-section home-expertise">
      <div className="home-shell">
        <div className="home-section-heading">
          <div><p className="home-eyebrow">02 / Areas of expertise</p><h2 className="home-section-title">The skills to see<br />the whole picture.</h2></div>
          <a href="/services" className="home-text-link">Find the right service <ArrowUpRightIcon aria-hidden="true" /></a>
        </div>
        <div className="home-expertise-grid">
          {perks.map((perk, index) => (
            <article key={perk.name} className="home-expertise-card">
              <div className="home-expertise-top"><img alt={`${perk.name} illustration`} src={perk.imageSrc} width="40" height="40" loading="lazy" decoding="async" /><span aria-hidden="true">0{index + 1}</span></div>
              <h3>{perk.name}</h3>
              <p>{perk.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Expertise
